import React from "react";

const DiscoveryHeader = ({ isFreeAgent, handleFreeAgentToggle }) => {
  return (
    <div className="py-4 px-4 sm:px-6 lg:px-12 border-b border-[#E5E6E8]">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="text-xl font-semibold">Discover</h1>
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-[#475467]">Free Agents</span>
          <button
            type="button"
            role="switch"
            aria-checked={isFreeAgent}
            onClick={handleFreeAgentToggle}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ${
              isFreeAgent ? "bg-blue-600" : "bg-gray-300"
            }`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform duration-200 ${
                isFreeAgent ? "translate-x-5" : "translate-x-1"
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscoveryHeader;
